const colors = {
  primary: '#0f132a',
  primaryContrast: '#fff',
  secondary: '#1ddd58',
  secondaryDark: '#14AE5C',
  errorDark: '#d0021b',
  success: '#3e8442',
  warning: '#fffa86',
  mediumNeutral: '#90939e',
  preOperational: '#f5a623',
  operational: '#286694',
  canceled: '#d0021b',
  textPrimary: '#0f132a',
  textSecondary: '#646464',
  white: '#fff',
  backgroundColor: '#F6F6F6',
  ctaColor: '#7d458e',
  ctaHover: '#663e73',
  darkNeutral: '#494B56',
  lightNeutral: '#f8f8f8',
};

export default { colors };
